<div class="business_client_list">
  <div class="client_header">
    <div class="client_details_info">Access Requests</div>
  </div>
  <div class="client_search">
    <mat-form-field class="client_form_fields" appearance="outline">
      <mat-label style="letter-spacing: 1px;word-spacing: 1px;">Search</mat-label>
      <input matInput type="text" style="font-family: var(--font);" placeholder="Search Client Details" />
      <mat-icon matSuffix style="color: black;">search</mat-icon>
    </mat-form-field>
  </div>
  <div class="client_details">
    <div *ngIf="!dataSource || dataSource.data.length === 0" class="no-data" style="text-align: center;">
      <img src="assets/svg/access.svg" alt="No accounts to display" class="access_image">
      <p style="font-family: var(--font); color: grey; font-size: 50px; text-align: center; padding: 10px 0px; line-height: 1;">
        No Request Available
      </p>
    </div>
    
    <div *ngIf="dataSource.data.length > 0" class="client_table_details">

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <!-- Business Name Column -->
        <ng-container matColumnDef="ClientName">
          <th mat-header-cell *matHeaderCellDef>Account Manager</th>
          <td mat-cell *matCellDef="let element">
            <div class="client_profile_container">
              <img [src]="element.ManagerPhoto" alt="Profile Photo" *ngIf="element.ManagerPhotoPic"
                class="client_profile_photo" />
              <span class="client_profile_phototext"
                *ngIf="!element.ManagerPhotoPic">{{element.ManagerImageText}}</span>
              <span style="font-family: var(--font); 
    font-size: 17px;
    letter-spacing: 0.8px;">{{element.ManagerFullName}} </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="ClientEmail">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">
            <span style="font-family: var(--font); 
    font-size: 17px;
    letter-spacing: 0.8px;">{{element.ManagerEmail}}</span>
          </td>
        </ng-container>
        <!-- Created On Column -->

        <!-- <ng-container matColumnDef="Phone_Number">
          <th mat-header-cell *matHeaderCellDef>Phone Number</th>
          <td mat-cell *matCellDef="let element">
            <span style="font-family: var(--font); 
    font-size: 17px;
    letter-spacing: 0.8px;">{{element.ManagerMobileNumber}}</span>
          </td>
        </ng-container> -->
        <ng-container matColumnDef="BusinessName">
          <th mat-header-cell *matHeaderCellDef> Business Name </th>
          <td mat-cell *matCellDef="let element">
            <div class="business-details-container">
              <span class="business-name">{{ element.BusinessInfo_BusinessName }}</span>
              <span class="business-details">
                {{ element.BusinessDetails }}
              </span>
            </div>
          </td>
        </ng-container>
        

        <ng-container matColumnDef="Created_On">
          <th mat-header-cell *matHeaderCellDef> Added On </th>
          <td mat-cell *matCellDef="let element" style="font-family: var(--font); 
    font-size: 17px;
    letter-spacing: 0.8px;"> {{element.CreatedOn_text}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element">
            <span style="display: flex; align-items: center;font-family: var(--font); 
    font-size: 17px;
    letter-spacing: 0.8px;">
              <span class="status-dot" [ngClass]="{
                      'accepted_status': element.Status === 'Approved',
                      'rejected_status': element.Status === 'Declined',
                      'pending_status': element.Status === 'Pending'
                    }" style="height: 10px; width: 10px; border-radius: 50%; margin-right: 5px;">
              </span>
              {{element.Status}}
            </span>
          </td>
        </ng-container>
        <!-- <ng-container matColumnDef="permission">
          <th mat-header-cell *matHeaderCellDef> Permission </th>
          <td mat-cell *matCellDef="let element" style="padding-left: 3%;">
            <div
              (click)="element.Status === 'Pending' ? permissionDetails(element.RequestId) : $event.stopPropagation()"
              [ngClass]="{'disabled_icon': element.Status !== 'Pending','pointer_icon': element.Status === 'Pending'}">
              <mat-icon>more_vert</mat-icon>
            </div>

          </td>
        </ng-container> -->
        <ng-container matColumnDef="call">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div style="display: flex; align-items: center;">
              <mat-icon 
                class="call-icon pointer_icon" 
                (click)="displayPhoneNumber(element.ManagerMobileNumber)">
                call
              </mat-icon>
              <div
                (click)="element.Status === 'Pending' ? permissionDetails(element.RequestId) : $event.stopPropagation()"
                [ngClass]="{'disabled_icon': element.Status !== 'Pending','pointer_icon': element.Status === 'Pending'}">
                <mat-icon>more_vert</mat-icon>
              </div>
            </div>
          </td>
        </ng-container>
        
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>